import { createRegexFromFormat } from './createRegexFromFormat'
import { parseFilenameByFormat } from './parseFilenameByFormat'
import { convertToKiddomHTMLStyle } from './convertToKiddomHTMLStyle'
import { generateRows } from './generateRows'

export function sliceContentsByCondition({
  contents,
  condition,
  type,
  exclude = 'NoClass',
  exactMatch = true,
}: {
  contents: Element[]
  condition: 'className' | 'tagName'
  type: string
  exclude?: string
  exactMatch?: boolean
  shouldConsole?: boolean
}) {
  const slices: { [key: string]: string } = {}
  let currentSlice = ''
  for (const element of contents) {
    if (element[condition] === exclude) {
      continue
    }
    const conditionMatch = exactMatch
      ? element[condition] === type
      : element[condition].includes(type)
    if (conditionMatch) {
      currentSlice = element.textContent?.trim().toUpperCase() || ''
      slices[currentSlice] = ''
      continue
    }
    if (currentSlice) {
      slices[currentSlice] = slices[currentSlice].concat(element.outerHTML)
    }
  }
  return slices
}

export function convertToCleanString({ content }: { content: string }) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  return doc.body.textContent
}

export function cleanListElement(content: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  const li = doc.querySelector('li')
  return li?.innerHTML || doc.body.innerHTML
}

export {
  createRegexFromFormat,
  parseFilenameByFormat,
  convertToKiddomHTMLStyle,
  generateRows,
}

// ✅ Helper function to get section content after an h3 and before the next h3
export function getSectionContent(startH3: Element): string {
  const contentNodes: string[] = []
  let sibling: ChildNode | null = startH3.nextSibling

  while (
    sibling &&
    !(
      sibling instanceof Element &&
      (sibling.tagName === 'H3' || sibling.tagName === 'H2')
    )
  ) {
    if (sibling.nodeType === Node.ELEMENT_NODE) {
      contentNodes.push((sibling as Element).outerHTML)
    } else if (sibling.nodeType === Node.TEXT_NODE) {
      contentNodes.push(sibling.textContent || '')
    }
    sibling = sibling.nextSibling
  }

  return contentNodes.join('')
}

// ✅ Helper: Get all <h3>s before the first <h2>
export function getH3sBeforeFirstH2(
  rootElement: Element,
): HTMLHeadingElement[] {
  const h3Elements: HTMLHeadingElement[] = []
  let foundH2 = false

  rootElement.childNodes.forEach((node) => {
    if (node instanceof Element && node.tagName === 'H2') {
      foundH2 = true
    }
    if (!foundH2 && node instanceof Element && node.tagName === 'H3') {
      h3Elements.push(node as HTMLHeadingElement)
    }
  })

  return h3Elements
}
